import { useEffect, useState } from "react";
import { useLineas } from "../../../NuevoPedido/componetizado/hooks/useLineas";
import { getRenglonesPedido } from "../services/edicionService";
import { esRenglonExistente, renglonApiALinea } from "../utils/renglones";

// Líneas de Editar Pedido: el núcleo compartido con Nuevo Pedido (useLineas)
// cargado con los renglones existentes del pedido.
//
// Los renglones existentes que se borran se guardan aparte ("eliminados") para
// darlos de baja al guardar; así la lista visible nunca tiene líneas borradas
// mezcladas y los índices de pantalla coinciden con los del array.
export const useLineasEditarPedido = ({ dataPedido, tabla, onErrorCarga }) => {
  const [eliminados, setEliminados] = useState([]);
  const [cargandoRenglones, setCargandoRenglones] = useState(true);

  const lineas = useLineas({
    uuidPedido: dataPedido.uuid_pedido,
    tabla,
    onLineaEliminada: (linea) => {
      if (esRenglonExistente(linea)) {
        setEliminados((prev) => [...prev, linea.id]);
      }
    },
  });
  const { setDatosRenglon } = lineas;

  useEffect(() => {
    let vigente = true;

    getRenglonesPedido(dataPedido.uuid_pedido)
      .then((renglones) => {
        if (vigente) setDatosRenglon(renglones.map(renglonApiALinea));
      })
      .catch((error) => {
        console.error("Error cargando renglones del pedido:", error);
        if (vigente) onErrorCarga("No se pudieron cargar los productos del pedido.");
      })
      .finally(() => {
        if (vigente) setCargandoRenglones(false);
      });

    return () => {
      vigente = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { ...lineas, eliminados, cargandoRenglones };
};
